var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TextFormGroup',{attrs:{"name":"url","label":"URL","error":(_vm.errors.url || [])[0],"help-text":"The YouTube or Vimeo URL"},model:{value:(_vm.data.url),callback:function ($$v) {_vm.$set(_vm.data, "url", $$v)},expression:"data.url"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }